// This store is for the courses for the login users.
/*eslint-disable */
import toast from '../services/toast'
import axios from 'axios';
import root from '../_helpers/roots';
import router from '../route';
// User Notes
let notesCreateLinkURL = root.notesCreateLink.link;
// User Note Files
let noteFilesUploadLinkURL = root.noteFilesUploadLink.link;

export default {
state: {
getuserNotesList: {},
getuserNotesListByid:{},
createduserNotesList: {},
updateduserNotesListByid:{},
createduserNoteFilesList:{},
getuserNoteFilesList:{},
updateduserNoteFilesList:{}
},
mutations: {
getUserNotesMutation(state, value) {
  state.getuserNotesList = value;
},
createdUserNotesMutation(state, value) {
  state.createduserNotesList = value;
},
getUserNotesByIdMutation(state, value) {
  state.getuserNotesListByid = value;
},
updatedUserNotesByIdMutation(state, value) {
  state.updateduserNotesListByid = value;
},
createdUserNoteFilesMutation(state, value) {
  state.createduserNoteFilesList = value;
},
getUserNoteFilesMutation(state, value) {
  state.getuserNoteFilesList = value;
},
updatedUserNoteFilesMutation(state, value) {
  state.updateduserNoteFilesList = value;
},
},
actions: {
getUserNotes(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(notesCreateLinkURL).then((response) => {
        context.commit('getUserNotesMutation', response.data);
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
},
getUserNotesByid(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(notesCreateLinkURL + payload.id + '/').then((response) => {
        context.commit('getUserNotesByIdMutation', response.data);
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
},
updatedUserNotesByid(context, payload) {
  return new Promise((resolve, reject) => {
    axios.patch(notesCreateLinkURL + payload.data.id + '/', payload.data.data).then((response) => {
        context.commit('updatedUserNotesByIdMutation', response.data);
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
},
removedUserNotesByid(context, payload) {
  return new Promise((resolve, reject) => {
    axios.delete(notesCreateLinkURL + payload.id + '/').then((response) => {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
},
createdUserNotes(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(notesCreateLinkURL, payload).then((response) => {
        context.commit('createdUserNotesMutation', response.data);
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
},
createdUserNoteFiles(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(noteFilesUploadLinkURL, payload).then((response) => {
        context.commit('createdUserNoteFilesMutation', response.data);
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
},
getUserNoteFilesById(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(noteFilesUploadLinkURL + payload.id + '/').then((response) => {
        context.commit('getUserNoteFilesMutation', response.data);
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
},
updatedUserNoteFilesById(context, payload) {
  return new Promise((resolve, reject) => {
    axios.patch(noteFilesUploadLinkURL + payload.data.id + '/', payload.data.data).then((response) => {
        context.commit('updatedUserNoteFilesMutation', response.data);
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
},
removedUserNoteFiles(context, payload) {
  return new Promise((resolve, reject) => {
    axios.delete(noteFilesUploadLinkURL + payload.id + '/').then((response) => {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  })
}
},
getters: {
  getuserNotesListState: state => state.getuserNotesList,
  createduserNotesListState: state => state.createduserNotesList,
  getuserNotesListByidState: state => state.getuserNotesListByid,
  updateduserNotesListByidState: state => state.updateduserNotesListByid,
  createduserNoteFilesListState: state => state.createduserNoteFilesList,
  getuserNoteFilesListState : state => state.getuserNoteFilesList,
  updateduserNoteFilesListState: state => state.updateduserNoteFilesList
}
}

//export default courses;